import { render, staticRenderFns } from "./SalesOrders.vue?vue&type=template&id=b827eafc&"
import script from "./SalesOrders.vue?vue&type=script&lang=js&"
export * from "./SalesOrders.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VDataTable})
